import {
    Table,
    TableHeader,
    TableColumn,
    TableBody,
    TableRow,
    TableCell,
    Skeleton,
} from "@heroui/react";

const DataTableSkeleton = ({ columns = [], rowCount = 10 }) => {
    return (
        <Table aria-label="Loading table" shadow="none">
            <TableHeader>
                {columns.map((col, idx) => (
                    <TableColumn key={idx} align={col.align || "start"}>
                        {col.name || ""}
                    </TableColumn>
                ))}
            </TableHeader>
            <TableBody>
                {[...Array(rowCount)].map((_, i) => (
                    <TableRow key={i}>
                        {columns.map((col, j) => (
                            <TableCell key={j}>
                                <div
                                    className={`flex w-full ${
                                        col.align === "end"
                                            ? "justify-end"
                                            : "justify-start"
                                    }`}
                                >
                                    <Skeleton
                                        className={`h-6 rounded-lg ${col.skeletonWidth || "w-full"}`}
                                    />
                                </div>
                            </TableCell>
                        ))}
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default DataTableSkeleton;
